import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  public errorMessage: string = '';
  public successMessage: string = '';
  public isSubmitting: boolean = false;
  public formSubmitted: boolean = false; // ✅ Added to control form visibility

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.isSubmitting = true;
    const { email } = this.forgotPasswordForm.value;

    this.authService.forgotPassword(email).subscribe({
      next: () => {
        this.successMessage = "A password reset link has been sent to your email.";
        this.errorMessage = '';
        this.isSubmitting = false;
        this.forgotPasswordForm.reset();
        this.formSubmitted = true; // ✅ Mark as submitted to trigger UI change

        // Optional redirect after a short delay (can be removed if manual redirect is preferred)
        // setTimeout(() => this.router.navigate(['/login']), 3000);
      },
      error: (error) => {
        console.error('Forgot password failed:', error);
        this.errorMessage = error.error?.message || "An error occurred during the request.";
        this.successMessage = '';
        this.isSubmitting = false;
      }
    });
  }
}
